import {
  addHealthInsurance,
  afterSuccessfulResolution
} from './checkout_insurance_helper';
import { API_REFERENCE } from '../utilities/constant_api';
import { formPost, htmlGet } from '../components/ajax';
import * as constantConfig from '../utilities/constant_config';
import { formatPhoneNumber } from '../utilities/utility';

const clsParentInsurance = '.checkout-insurance';
const addhealthInsuranceContainerId = '#show-add-health-insurance';
const clsAddNewInsuranceBtn = '.checkout-add-insurance__add-btn';
const addInsuranceImgClass = '.add-insurance-img';
const addInsuranceTextInnerClass = '.add-insurance-text__inner';
const clsAddInsuranceCancel = '.checkout-add-insurance__cancel';
const clsAddInsuranceAdd = '.checkout-add-insurance__add-btn';
const clsPayerPhoneNbr = '.payerPhoneNo';
const insuranceSearchResultsRadio =
  '.checkout-add-insurance input[name=insuranceSearchResult]';
const insuranceErrorsId = '#insurance-errors';
const checkoutHealthInsuranceView = '.account-health-insurance';
const clsCheckoutInsuranceState = '.health-add-insurance__select-state';
const strErrorMsgTextBox = 'error';
const clsErrorMsgText = '.error-msg-text';
const healthInsuranceFormId = '#health-add-insurance-search';
const clsTooltipIcon = '.status-info-icon';
const checkoutSelectMenuBtnId = '#stateInsurance-button';
const checkoutMenuHeader = '.nav-header';
const fromNoPayer = constantConfig.FROM_NO_PAYER;
const fromInsuranceView = constantConfig.FROM_INSURANCE_VIEW;
const fromErrorTile = constantConfig.FROM_ERROR_TILE;
const checkoutAddHealthInsuranceUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.addHealthInsurance}`;
const viewHealthInsuranceUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.viewHealthInsurance}`;
let checkoutAddNewInsuranceAjaxFlag = true;

const checkoutAddInsurance = {
  formatPhoneNumberInView() {
    // formatting phone number
    $(`${clsParentInsurance} ${checkoutHealthInsuranceView}`)
      .find(clsPayerPhoneNbr)
      .text(function(index, value) {
        return formatPhoneNumber(value);
      });
    $(`${clsParentInsurance} ${clsTooltipIcon}`).tooltip();
  },

  hideShowErrorAndView() {
    const parentStr = $(addhealthInsuranceContainerId).data('parent');
    $(addhealthInsuranceContainerId).hide();
    if (parentStr === fromErrorTile || parentStr === fromNoPayer) {
      $(insuranceErrorsId).show();
    } else if (parentStr === fromInsuranceView) {
      $(checkoutHealthInsuranceView).show();
    }
  },

  viewCheckoutHealthInsurance() {
    const addHealthInsuranceSection = $(
      `${clsParentInsurance} ${addhealthInsuranceContainerId}`
    );
    checkoutAddNewInsuranceAjaxFlag = false;
    htmlGet(viewHealthInsuranceUrl)
      .then(response => {
        checkoutAddNewInsuranceAjaxFlag = true;
        const sanitizedHtml = ACC.sanitizer.sanitizeHtmlDeeply(response);
        $(sanitizedHtml).insertAfter(addHealthInsuranceSection);
        checkoutAddInsurance.formatPhoneNumberInView();
        $(insuranceErrorsId).remove();
        $(addHealthInsuranceSection).hide();
        $(window).scrollTop(
          $(checkoutHealthInsuranceView).offset().top -
            parseInt($(checkoutMenuHeader).height())
        );
      })
      .catch(error => {
        checkoutAddNewInsuranceAjaxFlag = true;
      });
  },

  checkoutSelectedPlanProcess() {
    const parentStr = $(
      `${clsParentInsurance} ${addhealthInsuranceContainerId}`
    ).data('parent');
    if (parentStr === fromErrorTile) {
      checkoutAddNewInsuranceAjaxFlag = true;
      // If payer present
      checkoutAddInsurance.hideShowErrorAndView();
      afterSuccessfulResolution();
    } else {
      // if no payer /from insurance view
      checkoutAddInsurance.viewCheckoutHealthInsurance();
    }
  },

  checkoutAddNewInsurance() {
    var $spinner = $('#health-add-insurance .spinner-mask');
    $spinner.prop('hidden', false);
    const requiredInsurance = $(addhealthInsuranceContainerId).data(
      'requiredInsurance'
    );
    $('.global-error-message-container').addClass('hidden');
    let requiredData = $(healthInsuranceFormId).serialize();
    if (requiredInsurance.errorSubtype === constantConfig.EXPIRED_INSURANCE) {
      requiredData += `&expiredInsuranceFlow=true&planPosition=${requiredInsurance.payerPosition}&planIdToBeRemoved=${requiredInsurance.planIdToBeRemoved}&customerPlanRltIdToBeRemoved=${requiredInsurance.customerPlanRltIdToBeRemoved}`;
    }
    if (!checkoutAddNewInsuranceAjaxFlag) return false;
    checkoutAddNewInsuranceAjaxFlag = false;
    formPost(checkoutAddHealthInsuranceUrl, requiredData)
      .then(response => {
        const statusText = response !== '' ? JSON.parse(response) : {};
        if (statusText.status === constantConfig.SUCCESS) {
          checkoutAddInsurance.checkoutSelectedPlanProcess();
        } else if (statusText.status === constantConfig.ERROR) {
          checkoutAddNewInsuranceAjaxFlag = true;
          $('.global-error-message-container')
            .removeClass('hidden')
            .find('.generic-error-text')
            .text(statusText.errorMessage);
          $spinner.prop('hidden', true);
          window.scrollTo(0, 0);
        }
      })
      .catch(error => {
        checkoutAddNewInsuranceAjaxFlag = true;
        $spinner.prop('hidden', true);
      });
  },

  checkFlag() {
    return checkoutAddNewInsuranceAjaxFlag;
  },

  enableAddInsuranceButton() {
    $(clsAddInsuranceAdd).attr('disabled', false);
  },

  validateAddInsuranceSelectMenus() {
    const thisObj = $(this);
    if (!thisObj[0].validity.valueMissing) {
      thisObj
        .siblings('.ui-selectmenu-button')
        .removeClass(strErrorMsgTextBox)
        .removeClass('error-msg-textbox');
      thisObj.siblings(clsErrorMsgText).attr('hidden', true);
    }
  },

  init() {
    $(`${clsCheckoutInsuranceState}`).selectmenu({
      classes: {
        'ui-selectmenu-menu': 'checkout-insurance-select-menu'
      }
    });
    $('.health-add-insurance__select-policy').selectmenu();
    $(`${clsCheckoutInsuranceState},.health-add-insurance__select-policy`).on(
      'selectmenuchange',
      this.validateAddInsuranceSelectMenus
    );
    this.formatPhoneNumberInView();
    $(document).on(
      'click',
      `${addInsuranceImgClass},${addInsuranceTextInnerClass}`,
      addHealthInsurance
    );
    $(document).on('click', clsAddInsuranceCancel, this.hideShowErrorAndView);
    $(document).on(
      'change',
      insuranceSearchResultsRadio,
      this.enableAddInsuranceButton
    );
    $(document).on(
      'click',
      clsAddNewInsuranceBtn,
      this.checkoutAddNewInsurance
    );
  }
};
checkoutAddInsurance.init();
export default checkoutAddInsurance;
